import { render, staticRenderFns } from "./Pufa.vue?vue&type=template&id=6dcd2980&scoped=true"
import script from "./Pufa.vue?vue&type=script&lang=js"
export * from "./Pufa.vue?vue&type=script&lang=js"
import style0 from "./Pufa.vue?vue&type=style&index=0&id=6dcd2980&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd2980",
  null
  
)

export default component.exports